import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";
import { CONTACT, NAV, SOCIALS } from "@/lib/site";
import { Logo } from "./Logo";

const Col = ({ title, children }) => (
  <div>
    <h3 className="mb-4 text-[11px] font-bold uppercase tracking-[0.25em] text-slate-500">{title}</h3>
    <ul className="space-y-2.5 text-sm">{children}</ul>
  </div>
);

const FLink = ({ to, children, testid }) => (
  <li>
    <Link to={to} data-testid={testid} className="text-slate-300 transition-colors hover:text-[#00E5FF]">{children}</Link>
  </li>
);

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10 bg-[#071325]">
      <div className="h-1 w-full bg-gradient-to-r from-[#00E5FF] via-[#0A192F] to-[#FF5722]" />
      <div className="container-x grid gap-12 py-16 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div className="space-y-5">
          <Logo testid="footer-logo" />
          <p className="max-w-sm text-sm text-slate-400">
            A proposed 12-franchise T10 tennis-ball cricket league across Telangana and Andhra Pradesh.
          </p>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-300">Organised by <span className="text-[#FF5722]">CGN Sports</span></p>
          <div className="space-y-2 text-sm">
            <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="flex items-center gap-2 text-slate-300 hover:text-[#00E5FF]"><Mail className="h-4 w-4" />{CONTACT.email}</a>
            <a href={`tel:${CONTACT.tel}`} data-testid="footer-phone" className="flex items-center gap-2 text-slate-300 hover:text-[#00E5FF]"><Phone className="h-4 w-4" />{CONTACT.phone}</a>
          </div>
        </div>
        <Col title="Quick links">
          {NAV.slice(1, 8).map((n) => <FLink key={n.to} to={n.to}>{n.label}</FLink>)}
        </Col>
        <Col title="Get involved">
          <FLink to="/franchise#eoi" testid="footer-franchise-enquiry">Franchise enquiry</FLink>
          <FLink to="/players/register" testid="footer-player-registration">Player registration</FLink>
          <FLink to="/media#enquiry" testid="footer-media-enquiry">Media enquiry</FLink>
          <FLink to="/sponsors#enquiry" testid="footer-sponsor-enquiry">Sponsorship enquiry</FLink>
          <FLink to="/contact">Contact us</FLink>
        </Col>
        <Col title="Legal">
          <FLink to="/privacy-policy" testid="footer-privacy">Privacy policy</FLink>
          <FLink to="/terms" testid="footer-terms">Terms and conditions</FLink>
          <FLink to="/cookie-policy" testid="footer-cookies">Cookie policy</FLink>
          <FLink to="/disclaimer" testid="footer-disclaimer">Disclaimer</FLink>
        </Col>
      </div>
      <div className="border-t border-white/10">
        <div className="container-x flex flex-col gap-4 py-6 text-xs text-slate-500 md:flex-row md:items-center md:justify-between">
          <p>© {new Date().getFullYear()} Telangana–Andhra T10 League · CGN Sports. All rights reserved.</p>
          <div className="flex flex-wrap items-center gap-2" data-testid="footer-socials">
            <span className="mr-1 uppercase tracking-widest">Official social channels launching soon:</span>
            {SOCIALS.map((s) => (
              <span key={s.key} className="rounded-full border border-white/10 px-3 py-1 text-slate-400">{s.label}</span>
            ))}
            <Link to="/admin" data-testid="footer-admin-link" className="ml-2 text-slate-600 hover:text-slate-300">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
